<div class="modal active">
  <div class="modal__container modal__container--sm">

    <div class="fields">
      <h2 class="title">Cumulative Coverage Colors</h2>

      <div class="close" (click)="this.bsModalRef.hide()"><img src="/assets/img/close-white.svg" alt="" /></div>
      <div class="fields__container">
        <form autocomplete="off" [formGroup]="form" id="gradientColors" class="active">
          <div class="fields__block">
            <div class="fields__block__section">
              <div class="title mb-2">
                <h4>Gradient Colors</h4>
              </div>
              <div class="color_gradient">
                <div class="color_gradient_column">
                  <div class="color_gradient__row">
                    <label class="mb-0 mr-2" for="">First Layer</label>
                    <select class="mb-0 mr-2 color_gradient__row__max-width" [(ngModel)]="firstLayer" name="firstLayer"
                      [ngModelOptions]="{standalone: true}">
                      <option *ngFor="let value of layerIDs" [value]="value">{{value}}</option>
                    </select>
                    <input type="color" list="presetColors" name="firstLayerColor" [ngModelOptions]="{standalone: true}"
                      [(ngModel)]="firstLayerColor">
                      <label class="ml-2 mb-1 mt-1">to</label>
                      <datalist id="presetColors">
                        <option value="#ff0000">
                        <option value="#FFFF00">
                        <option value="#66FF66">
                        <option value="#00ff00">
                        <option value="#00ffff">
                        <option value="#0000ff">
                        <option value="#FFC0CB">
                        <option value="#C8A2C8">
                      </datalist>
                  </div>
                  <div class="color_gradient__row">
                    <label class="mb-0 mr-2" for="">Last Layer</label>
                    <input class="mb-0 mr-2 color_gradient__row__max-width" type="number" name="lastLayer"
                    formControlName="lastLayerForm" [(ngModel)]="lastLayer" required>
                    <span class="error" *ngIf="form.get('lastLayerForm').errors">
                      Last layer: Minimum value is 1.
                    </span>
                    <input type="color" list="presetColors" name="lastLayerColor" [(ngModel)]="lastLayerColor"
                    [ngModelOptions]="{standalone: true}">
                    <datalist id="presetColors">
                      <option value="#ff0000">
                      <option value="#FFFF00">
                      <option value="#66FF66">
                      <option value="#00ff00">
                      <option value="#00ffff">
                      <option value="#0000ff">
                      <option value="#FFC0CB">
                      <option value="#C8A2C8">
                    </datalist>
                  </div>
                </div>

              </div>
            </div>
          </div>
          <div class="fields__btn">
            <button type="submit" [ngClass]="form.valid ? 'blue' : 'gray'" [disabled]="!form.valid"
              (click)="applyGradient()">
              Apply Gradient
            </button>
          </div>
        </form>
        <div class="fields__block__section"  style="width: 100%;">
          <div class="title mb-2">
            <h4> Current Layer Colors</h4>
            <span></span>
          </div>
          <div class="table-fields">
            <div style="height: 330px;width: 100%; overflow-y: auto;">
              <table *ngIf="cumulativeCoverageColors != null">
                <thead>
                  <tr>
                    <td>Layer ID</td>
                    <td>Layer Color</td>
                  </tr>
                </thead>

                <tbody>
                  <tr mdbTable
                  *ngFor="let layerColor of cumulativeCoverageColors;let i = index">
                    <td>{{"Layer #"+ layerColor.id}} </td>
                    <td>
                      <input type="color" list="presetColors" name="layerColor_{{i}}" [(ngModel)]="layerColor.color">
                      <datalist id="presetColors">
                        <option value="#ff0000">
                        <option value="#FFFF00">
                        <option value="#66FF66">
                        <option value="#00ff00">
                        <option value="#00ffff">
                        <option value="#0000ff">
                        <option value="#FFC0CB">
                        <option value="#C8A2C8">
                      </datalist>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
        <div class="fields__btn">
          <button type="submit" [ngClass]="form.valid? 'blue' : 'gray'" [disabled]="!form.valid"
            (click)="applyChange();this.bsModalRef.hide()">
            Ok
          </button>
          <button class="gray" (click)="this.bsModalRef.hide()">
            Cancel
          </button>
        </div>
      </div>

    </div>
  </div>

</div>
